import { render } from "./AdminIndex.vue?vue&type=template&id=8ecfc10c&ts=true"
import script from "./AdminIndex.vue?vue&type=script&lang=ts"
export * from "./AdminIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__